export default __webpack_public_path__ + "static/media/logo.99f034f1.svg";